import {FC, useEffect, useState} from 'react'
import PaxElavonFullRefundButton from './PaxElavonFullRefundButton'
import PayConnectFullRefundButton from './PayConnectFullRefundButton'
import terminalService from 'app/services/TerminalService/TerminalService'
import {Spinner} from 'react-bootstrap'
import {PaxConnectionType} from 'app/constant'

interface Props {
  title?: string
  disabled?: boolean
  locationId: string
}

const PaxRefundButton: FC<Props> = ({locationId, ...props}) => {
  const [terminal, setTerminal] = useState<any>(null)
  useEffect(() => {
    const fetch = async () => {
      const terminal = await terminalService.getUserStripeTerminal(locationId)
      setTerminal(terminal)
    }
    fetch()
  }, [])

  if (terminal == null) {
    return (
      <div className='me-5'>
        <button id='btnSave' type='button' className='btn btn-primary btn-primary-active' disabled>
          Refund <Spinner size='sm' />
        </button>
      </div>
    )
  }

  if (terminal.paxConnectionType === PaxConnectionType.elavon) {
    return <PaxElavonFullRefundButton {...props} />
  }
  return <PayConnectFullRefundButton {...props} />
}

export default PaxRefundButton
